import { Injectable } from '@angular/core';
import { FormErrorModel } from '../models/common/form-error.model';
import { NumberConstants } from './number-constants';
import { AppConstants } from './app.constants';
@Injectable()
export class ErrorMessageConstants {
  public static readonly SOMETHING_WRONG: string =
    'Something went wrong, please try again later';
  public static readonly TOKEN_EXPIRED: string = 'Token expierd';
  public static readonly FORM_REQUIRE_FIELD = 'Required field';
  public static readonly FORM_INVALIED_EMAIL = 'Please enter a valid email id';
  public static readonly FORM_INVALIED_PASSWORD = 'Please enter valid password';
  public static readonly FORM_MAX_CHAR_LENGTH = 'Maximum %1 characters allowed';
  public static readonly FORM_MIN_CHAR_LENGTH =
    'Must contain minimum %1 characters';
  public static readonly FORM_PASSWORD_MATCH = 'Password does not match';
  public static readonly PASSWORD_UPPER_CASE_ERROR: string =
    'Password must contain at least one uppercase letter (A-Z)';
  public static readonly PASSWORD_LOWER_CASE_ERROR: string =
    'Password must contain at least one lowercase letter (a-z)';
  public static readonly PASSWORD_NUMBER_ERROR: string =
    'Password must contain at least one number (0-9)';
  public static readonly PASSWORD_SPECIAL_CHAR_MUST_ERROR: string =
    'Password must contain at least one special character @#&%*!~$^_';
  public static readonly PASSWORD_MIN_LENGTH_ERROR: string = `Password must be at least ${NumberConstants.PASSWORD_MIN_LENGTH} characters long`;
  public static readonly PASSWORD_MAX_LENGTH_ERROR: string = `Password must be at most ${NumberConstants.PASSWORD_MAX_LENGTH} characters long`;
  public static readonly PASSWORD_SPECIAL_CHAR_MUST_NOT_ERROR: string =
    'Password must not contain any special characters other than @#&%*!~$^_';
  public static readonly FORM_SELECT_TIMEZONE: string =
    'Please select a timezone';
  public static readonly IMAGE_SIZE_EXCEEDED: string =
    'File size cannot exceed more than 8MB.';
  public static readonly CONTROLLER_REBOOTED: string =
    'Controller reboot request initiated';

  public static readonly ENTER_FIRST_NAME: string = 'Enter first name';
  public static readonly ENTER_LAST_NAME: string = 'Enter last name';
  public static readonly INVALID_FIRST_NAME: string = 'Invalid first name';
  public static readonly INVALID_LAST_NAME: string = 'Invalid last name';
  public static readonly FIRST_LAST_NAME_MIN_LENGTH: string = `Must contain at least ${NumberConstants.FIRST_NAME_MIN_LENGTH} characters`;

  public static readonly FIRST_NAME_MAX_LENGTH: string = `Input has to be between ${NumberConstants.FIRST_NAME_MIN_LENGTH} to ${NumberConstants.FIRST_NAME_MAX_LENGTH} characters long`;
  public static readonly LAST_NAME_MAX_LENGTH: string = `Input has to be between ${NumberConstants.LAST_NAME_MIN_LENGTH} to ${NumberConstants.LAST_NAME_MAX_LENGTH}  characters long`;
  public static readonly FIRST_LAST_NAME_SPACE_ERROR: string =
    'Must not contain space';
  public static readonly FIRST_LAST_NAME_SPECIAL_CHAR_ERROR: string =
    'Must not contain special characters';

  public static readonly PROJECT_NAME_EMPTY: string =
    'Please provide Project name';
  public static readonly DESCRIPTION_EMPTY: string =
    'Please provide description';
  public static readonly DESCRIPTION_LENGTH: string = `Description should not exceed ${NumberConstants.PROJECT_DESCRIPTION_MAX_LENGTH} characters`;
  public static readonly PROJECT_NAME_MAX_LENGTH: string = `Project name should not exceed ${NumberConstants.PROJECT_NAME_MAX_LENGTH} characters`;
  public static readonly SELECT_IMAGE: string = 'Please upload image';
  public static readonly INVALID_FILES: string = `Please upload image in JPG,PNG,GIF,WEBP,BMP or JPEG format(Max size- ${Math.floor(
    AppConstants.MAX_FILE_SIZE / 1000 / 1000
  )}MB)`;
  public static readonly MAX_ALLOWED_FILE_COUNT: string =
    'Maximum %1 files are allowed';
  public static readonly FILE_SIZE_EXCEED: string =
    'File size exceeded %1. Please choose another file';
  public static readonly SAME_OLD_PASSWORD_ERROR =
    'New password should not be same as the old password';

  public static readonly PROJECT_ITEM_CARD_TITLE = 'Please provide card title';

  public static readonly PROJECT_ITEM_DESCRIPTION =
    'Please provide description';

  public static readonly PROJECT_ITEM_SELECT_CONTROLLER =
    'Please select controller';
  public static readonly PROJECT_ITEM_SELECT_DEVICE = 'Please select device';
  public static readonly PROJECT_ITEM_PARAMETER = 'Please select parameter';

  public static readonly PROJECT_ITEM_AGGREGATION = 'Please select aggregation';
  public static readonly PROJECT_ITEM_DURATION = 'Please select duration';
  public static readonly PROJECT_ITEM_VIEW_LIMIT = 'Please select view limit';
  public static readonly PROJECT_ITEM_DESCRIPTION_LENGTH: string = `Description should not exceed ${NumberConstants.PROJECT_ITEM_DESCRIPTION_MAX_LENGTH} characters`;
  public static readonly PROJECT_ITEM_HEADING_MAX_LENGTH: string = `Title should not exceed ${NumberConstants.PROJECT_ITEM_HEADING_MAX_LENGTH} characters`;

  public static readonly NO_SEARCH_RESULTS_FOUND = 'No Search Result Found';
  public static readonly NO_PROJECT_ACCESS =
    'You do not have access to this Project';

  public static readonly ITEM_ALREADY_ADDED = 'Item already added';
  public static readonly CONTROLLER_OFFLINE = 'Controller not reachable';
  public static readonly COLOUR_RANGE_REQUIRED = 'Please add missing colours';
  public static readonly COLOUR_RANGE_OVERLAP =
    'Range values cannot be overlaped';
  public static readonly NO_DEVICE_HEADING = 'Please enter a valid header';
  public static readonly NO_DEVICE_DESCRIPTION =
    'Please enter a valid description';
  public static readonly NO_DEVICE_CLIENT = 'Please enter a valid client';
  public static readonly NO_DEVICE_FACTORY = 'Please enter a valid factory';
  public static readonly NO_DEVICE_PLC_ID = 'Please enter a valid PLC ID';
  public static readonly NO_DEVICE_SLAVE_ADDRESS =
    'Please enter a valid slave address';
  public static readonly NO_DEVICE_SERIAL_NUMBER =
    'Please enter a valid serial number';

  public static readonly COLOUR_RANGE_HIGH_MIN_SAME_VALUE =
    'Minimum and maximum values cannot be the same';
  public static readonly RANGE_MIN_VALUE_LESS_THAN_MAX =
    'The minimum value of the range should be smaller than the maximum value';
  public static readonly NO_DATA_AVAILABLE = 'No data available';
  public static readonly COLOR_RANGE_MORE_THAN_RANGE =
    'Colour range should be within the allowed range';
  public static readonly COLOR_RANGE_MIN_GREATER_MAX =
    'Minimum colour range cannot be greater that maximum colour range';
  public static readonly APPLICATION_STATUS_UNAUTHORIZED_ACCESS =
    'You do not have access to this data';
  public static emailErrorKeyValues(maxLength: number): FormErrorModel[] {
    return [
      {
        key: 'required',
        value: this.FORM_REQUIRE_FIELD,
        isValid: true,
      },
      {
        key: 'email',
        value: this.FORM_INVALIED_EMAIL,
        isValid: true,
      },
      {
        key: 'maxlength',
        value: this.FORM_MAX_CHAR_LENGTH.replace('%1', maxLength.toString()),
        isValid: true,
      },
    ];
  }

  public static passwordErrorKeyValues(error: string): FormErrorModel[] {
    return [
      {
        key: 'required',
        value: this.FORM_REQUIRE_FIELD,
        isValid: true,
      },
      {
        key: '',
        value: error,
        isValid: error == '',
      },
    ];
  }

  public static reEnterPasswordErrorKeyValues(
    isMatch: boolean
  ): FormErrorModel[] {
    return [
      {
        key: 'required',
        value: this.FORM_REQUIRE_FIELD,
        isValid: true,
      },
      {
        key: '',
        value: this.FORM_PASSWORD_MATCH,
        isValid: isMatch,
      },
    ];
  }

  public static nameErrorKeyValues(error?: string): FormErrorModel[] {
    return [
      {
        key: 'required',
        value: this.FORM_REQUIRE_FIELD,
        isValid: true,
      },
      {
        key: '',
        value: error ?? '',
        isValid: (error?.length ?? '') == 0,
      },
    ];
  }

  public static maxLengthErrorKeyValues(maxLength: number): FormErrorModel[] {
    return [
      {
        key: 'maxlength',
        value: this.FORM_MAX_CHAR_LENGTH.replace('%1', maxLength.toString()),
        isValid: true,
      },
    ];
  }

  public static minMaxLengthErrorKeyValues(
    minLength: number,
    maxLength: number
  ): FormErrorModel[] {
    return [
      {
        key: 'required',
        value: this.FORM_REQUIRE_FIELD,
        isValid: true,
      },
      {
        key: 'maxlength',
        value: this.FORM_MAX_CHAR_LENGTH.replace('%1', maxLength.toString()),
        isValid: true,
      },
      {
        key: 'minlength',
        value: this.FORM_MIN_CHAR_LENGTH.replace('%1', minLength.toString()),
        isValid: true,
      },
    ];
  }

  public static addressErrorKeyValues(
    maxLength: number,
    minLength: number | undefined = undefined
  ): FormErrorModel[] {
    if (minLength) {
      return this.minMaxLengthErrorKeyValues(minLength, maxLength);
    }
    return this.maxLengthErrorKeyValues(maxLength);
  }
}
